import { render } from "./ViewAllMessages.vue?vue&type=template&id=51c432aa"
import script from "./ViewAllMessages.vue?vue&type=script&lang=js"
export * from "./ViewAllMessages.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jay/Downloads/exp/hl/msgui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__